/**
 * Same-tab navigation breadcrumb for error diagnosis.
 * Paths only — never query strings (secrets / form ids in search).
 */

import { pathOnly } from '@/lib/lark-error-redact';

const MAX_PATHS = 5;
const paths: string[] = [];

export function recordNavigationPath(pathname: string): void {
  const path = pathOnly(pathname);
  if (!path) return;
  if (paths[paths.length - 1] === path) return;
  paths.push(path);
  if (paths.length > MAX_PATHS) paths.shift();
}

export function recentNavigationPaths(): string[] {
  return [...paths];
}

export function resetNavigationPathsForTests(): void {
  paths.length = 0;
}
